/* src/app/coupons/coupon-dialog/coupon-dialog.component.css */
.full-width {
  width: 100%;
  margin-bottom: 8px;
}
.code-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 8px;
}
.code-field {
  flex: 1;
}
.generate-btn {
  margin-top: 4px;
  white-space: nowrap;
}
.two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 8px;
}
.two-col mat-form-field {
  width: 100%;
}
.form-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}
.toggle-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.toggles-row {
  display: flex;
  gap: 24px;
  margin: 12px 0;
}
.toggle-item {
  display: flex;
  align-items: center;
}
.preview-card {
  margin-top: 16px;
  background-color: #f5f5f5;
}
.preview-card mat-card-content {
  display: flex;
  align-items: center;
  gap: 8px;
  font-style: italic;
  color: #333;
}
.preview-icon {
  color: #e91e63;
}
mat-dialog-content {
  max-height: 70vh;
  overflow-y: auto;
  padding: 0 24px;
}
/*# sourceMappingURL=coupon-dialog.component.css.map */
